import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';

import Certificates from '../../../../components/certificates/certificates';
import { useTranslations } from '../../hooks/use-translations';
import UrlHelper from '../../../../helpers/url-helper';
import { END_DATE, START_DATE } from '../../../../helpers/constants';
import { useCertificatesConfig } from '../../config/certificates-config';
import css from '../single-class.scss';
import { ALL_GROUPS_ID } from '../../all-classes/all-classes-constants';
import {
    ALL_TEACHERS,
    ALL_YEARS
} from '../../../../components/report-filters/filter-constants';
import { ALL_TEACHERS_ID } from '../../participation-constants';
import { getCertificateFilename } from '../../helpers/utils';

const SingleClassCertificates = ({
    participationData,
    selectedClassroomId,
    selectedGroupId,
    newCertificatesDownloadByType,
    pastCertificatesDownloadByType,
    selectedYearGroupId,
    selectedTeacherId
}) => {
    const {
        newCertificatesConfig,
        pastCertificatesConfig
    } = useCertificatesConfig();
    const { certificates, oldCertificates } = useTranslations();
    const certificateProps = {
        classroomId: selectedClassroomId,
        startDate: UrlHelper.getQueryParamValue(START_DATE) || null,
        endDate: UrlHelper.getQueryParamValue(END_DATE) || null,
        groupId: selectedGroupId,
        isForDownload: true,
        ...(selectedYearGroupId !== ALL_YEARS && {
            yearGroupEnum: selectedYearGroupId
        }),
        teacherUserProfileId:
            selectedTeacherId === ALL_TEACHERS
                ? ALL_TEACHERS_ID
                : selectedTeacherId
    };

    const getNewCertificateDetails = () => {
        if (participationData) {
            if (selectedGroupId === ALL_GROUPS_ID)
                return participationData.newCertificateDetails;

            const currentGroup = participationData.classroomGroupParticipations.find(
                (classroomGroupParticipation) =>
                    classroomGroupParticipation.id === selectedGroupId
            );
            return currentGroup && currentGroup.newCertificateDetails;
        }

        return null;
    };

    return (
        <div className={css.certificates}>
            <Certificates
                config={newCertificatesConfig}
                heading={certificates}
                certificates={getNewCertificateDetails()}
                handleCertificateDownloadClick={(payload) => {
                    const { certificatesCount, certificateTypeName } = payload;
                    newCertificatesDownloadByType({
                        ...payload,
                        fileNameOverride: getCertificateFilename({
                            certificatesCount,
                            certificateTypeName,
                            title: participationData.classroomName,
                            prefixCertificate: false
                        })
                    });
                }}
                {...certificateProps}
            />
            <Certificates
                config={pastCertificatesConfig}
                heading={oldCertificates}
                isOldCertificates
                certificates={
                    participationData && participationData.certificateDetails
                }
                handleCertificateDownloadClick={(payload) => {
                    const { certificatesCount, certificateTypeName } = payload;
                    pastCertificatesDownloadByType({
                        ...payload,
                        fileNameOverride: getCertificateFilename({
                            certificatesCount,
                            certificateTypeName,
                            title: participationData.classroomName,
                            prefixCertificate: false
                        })
                    });
                }}
                {...certificateProps}
            />
        </div>
    );
};

SingleClassCertificates.propTypes = {
    participationData: PropTypes.object || null,
    selectedClassroomId: PropTypes.number,
    selectedGroupId: PropTypes.number,
    newCertificatesDownloadByType: PropTypes.func,
    pastCertificatesDownloadByType: PropTypes.func,
    selectedYearGroupId: PropTypes.number,
    selectedTeacherId: PropTypes.number
};

export default styleable(css)(SingleClassCertificates);



// WEBPACK FOOTER //
// ./containers/participation/single-class/components/single-class-certificates.js